function R(r) {
  const e = typeof r == "string" ? r.trim() : "";
  return e ? e.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e) ? "Enter a valid email address, such as name@example.com." : "" : "Please enter your email address.";
}
function U(r) {
  const e = typeof r == "string" ? r.trim().length : 0;
  return e < 20 ? `Please add at least 20 characters (${e}/20 so far).` : e > 5e3 ? "Please shorten your message to 5,000 characters or fewer." : "";
}
const M = [
  "Shopify theme",
  "Custom app",
  "Improvements",
  "Something else"
], j = [
  "Under £2,000",
  "£2,000–£5,000",
  "£5,000+",
  "Not sure yet"
];
function N(r) {
  const e = {}, n = {};
  for (const a of [
    "service",
    "name",
    "email",
    "website",
    "description",
    "budget",
    "company"
  ])
    e[a] = typeof (r == null ? void 0 : r[a]) == "string" ? r[a].trim() : "";
  M.includes(e.service) || (n.service = "Choose a project type."), (!e.name || e.name.length > 120) && (n.name = "Enter your name (up to 120 characters).");
  const t = R(e.email);
  t && (n.email = t);
  const i = U(e.description);
  if (i && (n.description = i), e.budget && !j.includes(e.budget) && (n.budget = "Choose one of the listed budgets."), e.website)
    try {
      const a = new URL(
        /^[a-z][a-z0-9+.-]*:/i.test(e.website) ? e.website : `https://${e.website}`
      );
      if (!["http:", "https:"].includes(a.protocol) || a.username || a.password || !a.hostname.includes(".") || e.website.length > 2048)
        throw new Error();
      e.website = a.href;
    } catch {
      n.website = "Enter a website address, such as example.com.";
    }
  return e.company && (n.company = "Unable to send this enquiry."), { data: e, errors: n };
}
function D(r) {
  const e = document.createElement("div");
  if (e.className = "enq-SuccessToast", e.setAttribute("aria-hidden", "true"), e.textContent = r, document.body.append(e), window.setTimeout(() => e.remove(), 9e3), window.matchMedia("(prefers-reduced-motion: reduce)").matches)
    return;
  const n = document.createElement("canvas");
  n.className = "enq-Confetti", n.setAttribute("aria-hidden", "true"), document.body.append(n);
  const t = n.getContext("2d");
  if (!t) {
    n.remove();
    return;
  }
  const i = ["#777e59", "#c88c72", "#d8b770", "#f5f2eb"];
  let a, g;
  function y() {
    a = innerWidth, g = innerHeight;
    const u = Math.min(devicePixelRatio || 1, 2);
    n.width = a * u, n.height = g * u, t.setTransform(u, 0, 0, u, 0, 0);
  }
  y(), window.addEventListener("resize", y);
  const w = Array.from({ length: 100 }, () => ({
    x: Math.random(),
    y: -Math.random() * 0.8,
    speed: 0.22 + Math.random() * 0.25,
    drift: Math.random() * 80 - 40,
    rotation: Math.random() * Math.PI,
    spin: Math.random() * 6 - 3,
    size: 5 + Math.random() * 5,
    color: i[Math.floor(Math.random() * i.length)]
  })), h = performance.now();
  function S(u) {
    const f = (u - h) / 1e3;
    if (f > 5 || document.hidden) {
      window.removeEventListener("resize", y), n.remove();
      return;
    }
    t.clearRect(0, 0, a, g), t.globalAlpha = Math.min(1, (5 - f) / 0.8);
    for (const o of w)
      t.save(), t.translate(
        o.x * a + Math.sin(f * 2 + o.rotation) * o.drift,
        (o.y + f * o.speed) * g
      ), t.rotate(o.rotation + f * o.spin), t.fillStyle = o.color, t.fillRect(
        -o.size / 2,
        -o.size / 2,
        o.size,
        o.size * 0.55
      ), t.restore();
    requestAnimationFrame(S);
  }
  requestAnimationFrame(S);
}
function B(r) {
  if (r.dataset.initialised)
    return;
  r.dataset.initialised = "true";
  const e = r.querySelector("form"), n = r.dataset.sectionId, t = {
    service: "contact[Project type]",
    name: "contact[name]",
    email: "contact[email]",
    website: "contact[Website]",
    description: "contact[body]",
    budget: "contact[Budget]",
    company: "contact[company]"
  }, i = e.elements.namedItem(t.description), a = e.querySelector('[data-error="description"]'), g = e.querySelector("[data-description-hint]");
  let y = !1;
  function w() {
    const c = U(i.value), b = i.value.trim().length;
    g.textContent = `${b.toLocaleString()} / 5,000 characters · minimum 20`, (i.value.length || y || i.getAttribute("aria-invalid") === "true") && (a.textContent = c, i.setAttribute("aria-invalid", String(!!c)));
  }
  i.addEventListener("blur", () => {
    y = !0, w();
  }), i.addEventListener("input", w), w();
  const h = e.elements.namedItem(t.email), S = e.querySelector('[data-error="email"]');
  let u = !1;
  function f() {
    const c = R(h.value);
    (h.value.length || u) && (S.textContent = c, h.setAttribute("aria-invalid", String(!!c)));
  }
  h.addEventListener("blur", () => {
    u = !0, f();
  }), h.addEventListener("input", f), h.addEventListener("change", f), e.noValidate = !0;
  const o = [
    "M3 5h18v14H3z M3 9h18 M7 5v4",
    "m8 8-4 4 4 4 m8-8 4 4-4 4 m-3-11-2 14",
    "m4 17 5-5 4 3 7-10 M15 5h5v5",
    "M5 5h14v11h-8l-6 4z"
  ];
  function L(c, b, A) {
    c.forEach((E, q) => {
      const v = document.createElement("label");
      v.className = b === "service" ? "enq-Service" : "enq-Choice";
      const p = document.createElement("input");
      p.type = "radio", p.name = t[b], p.value = E, b === "service" && (p.required = !0, p.setAttribute("aria-describedby", `enquiry-${n}-service-error`));
      const d = document.createElement("span");
      if (d.textContent = E, v.append(p), b === "service") {
        const m = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "svg"
        );
        m.setAttribute("viewBox", "0 0 24 24"), m.setAttribute("aria-hidden", "true");
        const l = document.createElementNS(m.namespaceURI, "path");
        l.setAttribute("d", o[q]), m.append(l), v.append(m);
      }
      v.append(d), A.append(v);
    });
  }
  L(M, "service", e.querySelector("[data-service-options]")), L(j, "budget", e.querySelector("[data-budget-options]"));
  const z = new URLSearchParams(location.search).get("service");
  M.includes(z) && ([...e.querySelectorAll("input[type=radio]")].find(
    (c) => c.name === t.service && c.value === z
  ).checked = !0);
  const s = e.querySelector("[data-client-status]"), x = e.querySelector("[data-submitted]");
  x && (x.focus({ preventScroll: !0 }), D(x.textContent.trim()));
  const P = e.querySelector("[data-server-errors]");
  P && P.focus({ preventScroll: !0 });
  let C = !1;
  e.addEventListener("submit", async (c) => {
    var p;
    if (c.defaultPrevented || (c.preventDefault(), C))
      return;
    const b = new FormData(e), A = Object.fromEntries(
      Object.entries(t).map(([d, m]) => [d, b.get(m)])
    ), { data: E, errors: q } = N(A);
    e.querySelectorAll("[data-error]").forEach((d) => {
      d.textContent = q[d.dataset.error] || "";
    });
    for (const [d, m] of Object.entries(t))
      [...e.elements].filter((l) => l.name === m).forEach(
        (l) => l.setAttribute("aria-invalid", String(!!q[d]))
      );
    if (Object.keys(q).length) {
      c.preventDefault(), s.textContent = "Please check the highlighted fields.", s.classList.add("enq-Status-error"), (p = e.querySelector("[aria-invalid=true]")) == null || p.focus({ preventScroll: !0 });
      return;
    }
    s.textContent = "", s.classList.remove("enq-Status-error"), e.elements.namedItem(t.website).value = E.website;
    const v = e.querySelector("[type=submit]");
    C = !0, v.disabled = !0, e.setAttribute("aria-busy", "true"), s.textContent = "Sending your enquiry…";
    try {
      const d = await fetch(e.action, {
        method: "POST",
        body: new FormData(e),
        credentials: "same-origin",
        signal: AbortSignal.timeout(3e4)
      });
      if (new URL(d.url).pathname.includes("/challenge")) {
        window.location.assign(d.url);
        return;
      }
      const l = new DOMParser().parseFromString(
        await d.text(),
        "text/html"
      ).getElementById(e.id), k = l == null ? void 0 : l.querySelector("[data-submitted]"), I = l == null ? void 0 : l.querySelector("[data-server-errors]");
      if (d.ok && k)
        e.reset(), u = !1, h.removeAttribute("aria-invalid"), S.textContent = "", a.textContent = "", y = !1, i.removeAttribute("aria-invalid"), w(), s.classList.remove("enq-Status-error"), s.classList.add("enq-Success"), s.textContent = k.textContent.trim(), s.focus({ preventScroll: !0 }), D(s.textContent);
      else if (I)
        s.textContent = I.textContent.trim(), s.classList.add("enq-Status-error"), s.focus({ preventScroll: !0 });
      else
        throw new Error("Unconfirmed submission");
    } catch {
      s.textContent = "Delivery could not be confirmed. Your details are still here. Please check before retrying.", s.classList.add("enq-Status-error"), s.focus({ preventScroll: !0 });
    } finally {
      C = !1, v.disabled = !1, e.removeAttribute("aria-busy");
    }
  });
}
document.querySelectorAll("[data-enquiry-root]").forEach(B);
document.addEventListener(
  "shopify:section:load",
  (r) => r.target.querySelectorAll("[data-enquiry-root]").forEach(B)
);
